import * as XLSX from 'xlsx'
import { ref, set, getDatabase } from 'firebase/database';
import firebaseConfig from '../Utilities/Firebase'
import { initializeApp } from 'firebase/app'

export const getAcceptedEntriesDataExcel = (data, batchYear) => {
    if(data.length > 0){

        let columnHeaders = ['SAP','Name','DOB','Contact','Department','Address','From','Date','Class','Message', "Gender"];

        let rows = []
        rows.push(columnHeaders);

        for (let i = 0; i < data.length; i++) {
            let eachRow = [];
            eachRow.push(data[i]['SAP']);
            eachRow.push(data[i]['Name']);
            eachRow.push(data[i]['DOB']);
            eachRow.push(data[i]['Contact']);
            eachRow.push(data[i]['Department']);
            eachRow.push(data[i]['Address']);
            eachRow.push(data[i]['From']);
            eachRow.push(data[i]['Date']);
            eachRow.push(data[i]['Class']);
            eachRow.push(data[i]['Message']);
            eachRow.push(data[i]['Gender'] ?? "");
            rows.push(eachRow);
        }

        var worksheet = XLSX.utils.aoa_to_sheet(rows);
        const wb = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        XLSX.writeFile(wb, `acceptedEntries_data.xlsx`)
    }
}

export const getNotCollectedEntriesDataExcel = (data) => {
    if(data.length > 0){

        let columnHeaders = ['SAP','Name','Department'];

        let rows = []
        rows.push(columnHeaders);

        for (let i = 0; i < data.length; i++) {
            let eachRow = [];
            eachRow.push(data[i]['SAP']);
            eachRow.push(data[i]['Name']);
            eachRow.push(data[i]['Department']);
            rows.push(eachRow);
        }

        var worksheet = XLSX.utils.aoa_to_sheet(rows);
        const wb = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        XLSX.writeFile(wb, `notCollectedEntries_data.xlsx`)
    }
}


export const handleFileUpload = (event) => {
    const FirebaseApp = initializeApp(firebaseConfig)
    const db = getDatabase(FirebaseApp)
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      data.forEach((row, index) => {
        if (index > 0) { // skip header row
          const railwayRef = ref(db, 'railway_notcollected/' + row[1]);
          set(railwayRef, {
            SAP: row[1],
            Name: row[2],
            Department: row[3],
          });
        }
      });
    };
    reader.readAsBinaryString(file);
  };
  